<script lang="ts">
  import { X } from 'lucide-svelte';
  import type { Snippet } from 'svelte';

  const {
    title,
    onClose,
    children,
    wide = false
  }: { title: string; onClose: () => void; children: Snippet; wide?: boolean } = $props();

  function onKeydown(e: KeyboardEvent) {
    if (e.key === 'Escape') onClose();
  }
</script>

<svelte:window onkeydown={onKeydown} />

<!-- svelte-ignore a11y_click_events_have_key_events -->
<!-- svelte-ignore a11y_no_static_element_interactions -->
<div
  class="fixed inset-0 z-40 flex items-start justify-center overflow-y-auto bg-[rgba(7,14,25,.55)] px-3 py-6 backdrop-blur-[3px] sm:items-center sm:px-4 sm:py-10 [animation:fade_.16s]"
  role="presentation"
  onclick={onClose}
>
  <!-- svelte-ignore a11y_click_events_have_key_events -->
  <div
    class="tym-modal-dialog w-full {wide
      ? 'max-w-[720px]'
      : 'max-w-[460px]'} rounded-[16px] border border-border bg-[var(--tym-white)] shadow-[var(--tym-shadow-3)] [animation:pop_.18s_var(--tym-ease-out)]"
    role="dialog"
    aria-modal="true"
    tabindex="-1"
    onclick={(e) => e.stopPropagation()}
  >
    <div class="flex shrink-0 items-center justify-between p-5 pb-4 sm:p-[26px] sm:pb-4">
      <h2 class="font-heading text-lg font-bold text-navy">{title}</h2>
      <button type="button" onclick={onClose} class="text-dark-gray hover:text-navy" aria-label="Close">
        <X class="h-5 w-5" />
      </button>
    </div>
    <div class="tym-modal-body px-5 pb-5 sm:px-[26px] sm:pb-[26px]">
      {@render children()}
    </div>
  </div>
</div>
